import { createContext } from 'react';

export const DestinationContext = createContext(false);
